module.exports = __webpack_public_path__ + "img/orthotic-functional.9d87f87d.png";